import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { OverlayTrigger } from 'react-bootstrap';

import EditPopover from './EditPopover';
import EditModal from './EditModal';
import RejectPopover from './RejectPopover';

import taskActions from '../actions/taskActionCreators';

require.ensure([], () => {  
    require('./DurationSetPill.less');
    require('./Pills.less');
});

class DurationSetPill extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        if (this.props.getPill)
            this.props.getPill(this);

        this.state = {
            showModal: false
        };
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleDragStart = (dragEvent) => {
        // close the popover immediately
        if (!this.props.modalPopover)
            this.handlePopoverClose();

        dragEvent.dataTransfer.setData('application/json', JSON.stringify(this.props.logEntry));

        if (dragEvent.ctrlKey) {
            dragEvent.dataTransfer.effectAllowed = "copy";
        } else {
            dragEvent.dataTransfer.effectAllowed = "move";
        }
    }

    handleHideModal = () => {
        this.setState({
            showModal: false
        });
    }

    handlePopoverClose = () => {
        if (!this.props.modalPopover && this.refs.popoverTrigger)
            this.refs.popoverTrigger.hide();
    }

    handleShowModal = () => {

        this.props.closeAllPopovers();

        

        let selectedTask = {};
        selectedTask.projectName = this.props.logEntry.projectName;
        selectedTask.projectID = this.props.logEntry.projectID;
        selectedTask.name = this.props.logEntry.taskName;
        selectedTask.id = this.props.logEntry.taskID;
        this.props.dispatch(taskActions.setSelectedTask(selectedTask));

        this.setState({
            showModal: true
        });
    }

    // RENDER METHOD

    render = () => {
        if (this.props.logEntry === null)
            return null;

        // format duration into HH:MM without the leading zero
        let hours = Math.floor(this.props.logEntry.duration / 60);
        let minutes = this.props.logEntry.duration % 60;

        let duration = "";

        if (hours > 0) {
            duration += hours + "h ";
        }

        if (minutes > 0) {
            duration += minutes + "min";
        }

        if (duration === "") {
            duration = "0min";
        }

        // prevents ugly NaN:NaN display
        if (isNaN(hours)) hours = "0";
        if (isNaN(minutes)) minutes = "00";

        // cut the seconds from HH:mm:ss formatted start time
        let startTime = this.props.logEntry.startTime;

        if (startTime && startTime.length > 5)
            startTime = this.props.logEntry.startTime.substr(0, this.props.logEntry.startTime.lastIndexOf(':'));

        let pillStyles = {};

        if (this.props.logEntry.projectName) {
            pillStyles['borderLeft'] = "10px solid " + this.props.logEntry.color;
        }

        let pillClassNames;

        if (!this.props.logEntry.projectName) {
            pillClassNames = "floating";
        }

        let durationStyle = {};

        if (this.props.logEntry.overtime) {
            durationStyle = {"color" : "red"};
        }

        let mindivHeight = hours * 35 + (minutes/60) * 35;
        if(hours < 1) {
            mindivHeight = 35;
        }

        let rejectPopover = <RejectPopover
                                parent={this}
                                smartPopoverPlacement={this.props.smartPopoverPlacement}
                                message={this.props.logEntry.rejectMessage}
                                />;

        if (!this.props.modalPopover) {
            let popover = (
                <EditPopover
                    tasks={this.props.tasks}
                    parent={this}
                    timesheet={this.props.timesheet}
                    logEntry={this.props.logEntry}
                    editForUser={this.props.editForUser}
                    close={this.handlePopoverClose}
                    smartPopoverPlacement={this.props.smartPopoverPlacement}
                    pmoMode={this.props.pmoMode}
                    pmo={this.props.pmo}
                    returnKeymaster={this.props.returnKeymaster}
                    logEntries={this.props.logEntries}
                    />
            );

            return (
                <OverlayTrigger trigger="click" ref="popoverTrigger" placement="right" overlay={popover}>
                    <li className={pillClassNames} style={pillStyles} tabIndex="-1" draggable={this.props.draggable} onDragStart={this.handleDragStart} onClick={this.handleShowModal}>
                        <div className="task" style={{minHeight: mindivHeight + "px"}}>
                            <h4 style={{ wordWrap: "break-word" }}>{ this.props.logEntry.projectName ? this.props.logEntry.projectName : "FLOATING TASK" }</h4>
                            <h5 style={{ wordWrap: "break-word" }} title={this.props.logEntry.alias ? this.props.logEntry.taskName : null}>{ this.props.logEntry.alias ? this.props.logEntry.alias : this.props.logEntry.taskName }</h5>
                            <h6 style={{ wordWrap: "break-word", whiteSpace: "pre-wrap" }}>{ this.props.logEntry.description }</h6>
                            <span style={{"display": "inline-block"}} className="logentry-timesheet-status-show">
                                {
                                    this.props.logEntry.status === "REJECTED" ?
                                    <OverlayTrigger ref="popoverTrigger2" placement="right" overlay={rejectPopover}>
                                        <i style={{"color": "#cc2200"}} className="md-warning"/>
                                    </OverlayTrigger>
                                    : null
                                }
                                { this.props.logEntry.status === "ACCEPTED" ? <i title="Approved log record" style={{"color": "green"}} className="md-done"/> : null }
                                { this.props.logEntry.status === "SUBMITTED" ? <i title="Submitted log record" className="md-person"/> : null }
                                { !this.props.pmo && 
                                    this.props.editForUser && 
                                    this.props.logEntry.lastModifiedByUser && 
                                    this.props.logEntry.lastModifiedByUser !== (this.props.editForUser.givenName + " " + this.props.editForUser.surname + " (" + this.props.editForUser.username + ")") ? "PMO" : null }
                                { this.props.pmo && 
                                    this.props.editForUser && 
                                    this.props.editForUser.id !== this.props.pmo.id && 
                                    this.props.logEntry.lastModifiedByUser && 
                                    this.props.logEntry.lastModifiedByUser !== (this.props.editForUser.givenName + " " + this.props.editForUser.surname + " (" + this.props.editForUser.username + ")") ? " PMO" : null }
                                { this.props.pmo && 
                                    this.props.editForUser && 
                                    this.props.editForUser.id === this.props.pmo.id && 
                                    this.props.logEntry.lastModifiedByUser && 
                                    this.props.logEntry.lastModifiedByUser !== (this.props.pmo.givenName + " " + this.props.pmo.surname + " (" + this.props.pmo.username + ")") ? " PMO" : null }
                            </span>
                            <span className="duration-show" style={durationStyle}>
                                {
                                    hours > 0
                                    ? (hours + "h")
                                    : null
                                }
                                &nbsp;
                                {
                                    minutes > 0
                                    ? (minutes + "min")
                                    : null
                                }
                            </span>
                        </div>
                    </li>
                </OverlayTrigger>
            );
        } else {
            let modal = (
                <EditModal
                    parent={this}
                    timesheet={this.props.timesheet}
                    logEntry={this.props.logEntry}
                    editForUser={this.props.editForUser}
                    close={this.handleHideModal}
                    onRequestHide={this.handleHideModal}
                    smartPopoverPlacement={this.props.smartPopoverPlacement}
                    returnKeymaster={this.props.returnKeymaster}
                    tasks={this.props.tasks}
                    logEntries={this.props.logEntries}
                    />
            );

            return (
                    <li  className={pillClassNames} style={pillStyles} tabIndex="-1" draggable={this.props.draggable} onDragStart={this.handleDragStart} onClick={this.handleShowModal}>
                        {
                            this.state.showModal ? modal : null
                        }
                        <div className="task" style={{minHeight: mindivHeight + "px"}}>
                            <h4 style={{ wordWrap: "break-word" }}>{ this.props.logEntry.projectName ? this.props.logEntry.projectName : "FLOATING TASK" }</h4>
                            <h5 style={{ wordWrap: "break-word" }} title={this.props.logEntry.alias ? this.props.logEntry.taskName : null}>{ this.props.logEntry.alias ? this.props.logEntry.alias : this.props.logEntry.taskName }</h5>
                            <h6 style={{ wordWrap: "break-word", whiteSpace: "pre-wrap" }}>{ this.props.logEntry.description }</h6>
                            <span className="logentry-timesheet-status-show">
                                {
                                    this.props.logEntry.status === "REJECTED" ?
                                    <OverlayTrigger ref="popoverTrigger2" placement="right" overlay={rejectPopover}>
                                        <i style={{"color": "#cc2200"}} className="md-warning"/>
                                    </OverlayTrigger>
                                    : null
                                }
                                { this.props.logEntry.status === "ACCEPTED" ? <i title="Approved log record" style={{"color": "green"}} className="md-done"/> : null }
                                { this.props.logEntry.status === "SUBMITTED" ? <i title="Submitted log record" className="md-person"/> : null }
                            </span>
                            <span className="duration-show" style={durationStyle}>
                                {
                                    hours > 0
                                    ? (hours + "h")
                                    : null
                                }
                                &nbsp;
                                {
                                    minutes > 0
                                    ? (minutes + "min")
                                    : null
                                }
                            </span>
                        </div>
                    </li>
            );
        }
    }
}

DurationSetPill.propTypes = {
    createLogEntry: React.PropTypes.func,
    currentUser: React.PropTypes.object,
    dispatch: PropTypes.func,
    draggable: PropTypes.bool,
    editForUser: PropTypes.object,
    id: PropTypes.number,
    logEntries: PropTypes.array,
    logEntry: React.PropTypes.object.isRequired,
    modalPopover: PropTypes.bool,
    pmo: PropTypes.object,
    pmoMode: PropTypes.bool,
    returnKeymaster: PropTypes.func,
    smartPopoverPlacement: PropTypes.bool,
    updateLogEntry: React.PropTypes.func,
    tasks: PropTypes.array,
    timesheet: PropTypes.object
};

DurationSetPill.defaultProps = {
    draggable: false
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DurationSetPill);


/** WEBPACK FOOTER **
 ** ./src/app/components/DurationSetPill.js
 **/